/**
 * callConstants.js
 * Talkroute
 *
 * Created by Vel Genov on 7/23/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Constants representing different states a call goes through
 */

export enum CallStateEnum {
  IDLE = "Idle",
  STARTING_CALL = "StartingCall",
  CONNECTING = "Connecting",
  CONNECTED = "Connected",
  INCOMING = "Incoming",
  ACCEPT = "Accept",
}

export enum CallTypeEnum {
  INCOMING = "Incoming",
  OUTGOING = "Outgoing",
}
